import logger from '../../utils/src/logger';
import * as BasePrototype from './BasePrototype';
import * as mithril from './mithril';
import elementQueries from './elementQueries';
import { __createElement } from './BasePrototype/RenderHandling';
import { isPrimitiveRegion } from './BasePrototype/RegionHandling';
export { mithril };
export { __createElement };
export { isPrimitiveRegion as __isPrimitiveRegion };
export { default as config } from '../../utils/src/config';
export { logger };
export { elementQueries };
/**
 * Creates a component class from a given definition.
 *
 * @params {string} componentName - Expects a unique component name.
 * @params {Object} definition - Component definition
 */
export function __addComponent(componentName, definition) {
    return createComponentClass(componentName, definition);
}
/**
 * Creates multiple component classes from a given definition.
 *
 * @params {string} componentName - Expects a unique component name.
 * @params {Object} definition - Component definition
 */
export function __addComponents(componentName, definition) {
    return componentName.map(function (name) { return createComponentClass(name, definition); });
}
function createComponentClass(componentName, definition) {
    var _a;
    if (!componentName || componentName.trim() === '' || !definition) {
        logger.error('Expect a component name and custom element definition');
        return null;
    }
    // This limitation comes from the fact that we cannot log metrics that are longer than 32 characters
    if (componentName.replace(/-/g, '').length > 27) {
        logger.error("Component name " + componentName + " contains more than 27 characters (excluding '-')");
        return null;
    }
    var basePrototype = BasePrototype.createComponentPrototype(componentName, definition);
    return _a = /** @class */ (function () {
            function AwsUiComponent() {
            }
            return AwsUiComponent;
        }()),
        _a.awsUi = {
            wrapperSupport: definition.wrapperSupport,
            name: componentName
        },
        _a.componentDefinition = definition,
        _a.basePrototype = basePrototype,
        _a;
}
/**
 * This is a public method for community based components.
 * It is overriden by the wrappers.
 * We need it also in runtime for unit tests, when there is no wrapper.
 */
export { __addComponent as addComponent };
/**
 * Checks if the given element constructor defines a component.
 *
 * @abstract
 * @params {any} ElementClass
 */
export function __isComponent(ElementClass) {
    return !!ElementClass.componentDefinition;
}
export function activate(node, ComponentClass, extensions) {
    if (extensions === void 0) { extensions = {}; }
    if (!(node instanceof Node)) {
        logger.error('Expected a Node');
        return;
    }
    node.component = Object.create(ComponentClass.basePrototype);
    Object.keys(extensions).forEach(function (key) {
        node.component[key] = extensions[key];
    });
    node.component.node = node;
    node.component.hasBeenCreated();
}
/**
 * Creates a Custom Element node with the given hash of properties.
 * It will lookup whether a component with the given name exists
 * and instantiate it.
 * After calling the created callback for the Custom Element, it will set the
 * given properties.
 * @abstract
 * @params {string} componentName - The name of the component
 * @returns {HTMLElement} Instantiated node of the component prototype
 */
export function createComponent(ComponentClass) {
    if (!ComponentClass) {
        logger.error('No component class given');
        return;
    }
    var node = document.createElement(ComponentClass.awsUi.name);
    activate(node, ComponentClass);
    return node;
}
//# sourceMappingURL=AwsUi.js.map